export default "__VITE_ASSET__DN2rwlVQ__"